import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import styled from "styled-components";
import Architecture from "./Architecture";
import BookingLifecycle from "./BookingLifecycle";
import DataFlow from "./DataFlow";
import PlatformOverview from "./PlatformOverview";
import Training from "./Training";
import ModuleGuard from "../../PrivateRoute/ModuleGuard";

const DocContainer = styled.div`
  --doc-bg: #e3e8ea;
  --doc-primary: #004d2c;
  --doc-emerald: #10b981;
  --doc-text: #374151;
  --doc-header: #1f2937;
  
  background: var(--doc-bg);
  min-height: calc(100vh - 64px);
  font-family: 'Metropolis', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--doc-text);
  margin: -1rem; /* Offset the padding from the main layout */
`;

export default function DocumentationHub() {
  return (
    <DocContainer>
      <div className="p-4">
        <Routes>
          <Route path="architecture" element={<ModuleGuard modulePath="/documentation/architecture"><Architecture /></ModuleGuard>} />
          <Route path="booking-lifecycle" element={<ModuleGuard modulePath="/documentation/booking-lifecycle"><BookingLifecycle /></ModuleGuard>} />
          <Route path="data-flow" element={<ModuleGuard modulePath="/documentation/data-flow"><DataFlow /></ModuleGuard>} />
          <Route path="platform-overview" element={<ModuleGuard modulePath="/documentation/platform-overview"><PlatformOverview /></ModuleGuard>} />
          <Route path="training" element={<ModuleGuard modulePath="/documentation/training"><Training /></ModuleGuard>} />
          <Route index element={<Navigate to="architecture" replace />} />
        </Routes>
      </div>
    </DocContainer>
  );
}
